import tuitionDetailService from '../../services/tuitionDetail.service';

export const tuitionDetailConstants = {
  GETALL_REQUEST: 'TUITION_DETAIL_GETALL_REQUEST',
  GETALL_SUCCESS: 'TUITION_DETAIL_GETALL_SUCCESS',
  GETALL_FAILURE: 'TUITION_DETAIL_GETALL_FAILURE',

  GETBYID_REQUEST: 'TUITION_DETAIL_GETBYID_REQUEST',
  GETBYID_SUCCESS: 'TUITION_DETAIL_GETBYID_SUCCESS',
  GETBYID_FAILURE: 'TUITION_DETAIL_GETBYID_FAILURE',

  CREATE_REQUEST: 'TUITION_DETAIL_CREATE_REQUEST',
  CREATE_SUCCESS: 'TUITION_DETAIL_CREATE_SUCCESS',
  CREATE_FAILURE: 'TUITION_DETAIL_CREATE_FAILURE',

  BATCH_CREATE_REQUEST: 'TUITION_DETAIL_BATCH_CREATE_REQUEST',
  BATCH_CREATE_SUCCESS: 'TUITION_DETAIL_BATCH_CREATE_SUCCESS',
  BATCH_CREATE_FAILURE: 'TUITION_DETAIL_BATCH_CREATE_FAILURE',

  DELETE_REQUEST: 'TUITION_DETAIL_DELETE_REQUEST',
  DELETE_SUCCESS: 'TUITION_DETAIL_DELETE_SUCCESS',
  DELETE_FAILURE: 'TUITION_DETAIL_DELETE_FAILURE',

  GET_STATISTICS_REQUEST: 'TUITION_DETAIL_GET_STATISTICS_REQUEST',
  GET_STATISTICS_SUCCESS: 'TUITION_DETAIL_GET_STATISTICS_SUCCESS',
  GET_STATISTICS_FAILURE: 'TUITION_DETAIL_GET_STATISTICS_FAILURE',
};

export const tuitionDetailActions = {
  getAll,
  getById,
  createOrUpdate,
  batchCreateOrUpdate,
  deleteDetail,
  getStatistics,
};

function getAll(filters?: any) {
  return (dispatch: any) => {
    dispatch(request());

    return tuitionDetailService.getAll(filters)
      .then(
        (response) => {
          dispatch(success(response.data));
          return response;
        },
        (error) => {
          dispatch(failure(error.toString()));
          return Promise.reject(error);
        }
      );
  };

  function request() {
    return { type: tuitionDetailConstants.GETALL_REQUEST };
  }
  function success(data: any) {
    return { type: tuitionDetailConstants.GETALL_SUCCESS, data };
  }
  function failure(error: any) {
    return { type: tuitionDetailConstants.GETALL_FAILURE, error };
  }
}

function getById(id: number) {
  return (dispatch: any) => {
    dispatch(request());

    tuitionDetailService.getById(id)
      .then(
        (response) => dispatch(success(response.data)),
        (error) => dispatch(failure(error.toString()))
      );
  };

  function request() {
    return { type: tuitionDetailConstants.GETBYID_REQUEST };
  }
  function success(data: any) {
    return { type: tuitionDetailConstants.GETBYID_SUCCESS, data };
  }
  function failure(error: any) {
    return { type: tuitionDetailConstants.GETBYID_FAILURE, error };
  }
}

function createOrUpdate(tuitionDetail: any) {
  return (dispatch: any) => {
    dispatch(request());

    tuitionDetailService.createOrUpdate(tuitionDetail)
      .then(
        (response) => {
          dispatch(success(response.data));
          return response;
        },
        (error) => {
          dispatch(failure(error.toString()));
          throw error;
        }
      );
  };

  function request() {
    return { type: tuitionDetailConstants.CREATE_REQUEST };
  }
  function success(data: any) {
    return { type: tuitionDetailConstants.CREATE_SUCCESS, data };
  }
  function failure(error: any) {
    return { type: tuitionDetailConstants.CREATE_FAILURE, error };
  }
}

function batchCreateOrUpdate(tuitionDetails: any[]) {
  return (dispatch: any) => {
    dispatch(request());

    return tuitionDetailService.batchCreateOrUpdate(tuitionDetails)
      .then(
        (response) => {
          dispatch(success(response.data));
          return response;
        },
        (error) => {
          dispatch(failure(error.toString()));
          throw error;
        }
      );
  };

  function request() {
    return { type: tuitionDetailConstants.BATCH_CREATE_REQUEST };
  }
  function success(data: any) {
    return { type: tuitionDetailConstants.BATCH_CREATE_SUCCESS, data };
  }
  function failure(error: any) {
    return { type: tuitionDetailConstants.BATCH_CREATE_FAILURE, error };
  }
}

function deleteDetail(id: number) {
  return (dispatch: any) => {
    dispatch(request());

    tuitionDetailService.delete(id)
      .then(
        () => dispatch(success(id)),
        (error) => dispatch(failure(error.toString()))
      );
  };

  function request() {
    return { type: tuitionDetailConstants.DELETE_REQUEST };
  }
  function success(id: number) {
    return { type: tuitionDetailConstants.DELETE_SUCCESS, id };
  }
  function failure(error: any) {
    return { type: tuitionDetailConstants.DELETE_FAILURE, error };
  }
}

function getStatistics(filters: any) {
  return (dispatch: any) => {
    dispatch(request());

    tuitionDetailService.getStatistics(filters)
      .then(
        (response) => dispatch(success(response.data)),
        (error) => dispatch(failure(error.toString()))
      );
  };

  function request() {
    return { type: tuitionDetailConstants.GET_STATISTICS_REQUEST };
  }
  function success(data: any) {
    return { type: tuitionDetailConstants.GET_STATISTICS_SUCCESS, data };
  }
  function failure(error: any) {
    return { type: tuitionDetailConstants.GET_STATISTICS_FAILURE, error };
  }
}
